// export  const  fetchUrl = 'http://127.0.0.1:8000'
export const fetchUrl = "https://backend.nsverityshop.com";